import { connect } from 'react-redux'
import { setErrorMessage } from 'actions/account'

const mapStateToProps = () => ({})
const actions = { setErrorMessage }

const withRedux = connect(mapStateToProps, actions)

export default withRedux
